import React, { useEffect, useMemo, useState } from 'react';
import API from './services/api';

const base64ToUint8 = (base64) => {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return bytes;
};

export default function FLHAAcknowledgmentPublic() {
  const token = useMemo(() => {
    try {
      return new URLSearchParams(window.location.search).get('token');
    } catch {
      return null;
    }
  }, []);

  const [loading, setLoading] = useState(true);
  const [invitation, setInvitation] = useState(null);
  const [submission, setSubmission] = useState(null);
  const [pdfBase64, setPdfBase64] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [submittedStatus, setSubmittedStatus] = useState(null);

  useEffect(() => {
    if (!token) {
      setLoading(false);
      return;
    }

    API.get(`/api/flha/acknowledgment/${encodeURIComponent(token)}`)
      .then((res) => {
        const data = res?.data || {};
        setInvitation(data.invitation || null);
        setSubmission(data.submission || null);
        setPdfBase64(data.pdfBase64 || null);
      })
      .catch((err) => {
        console.error('Invalid or expired FLHA token', err);
        setInvitation(null);
      })
      .finally(() => setLoading(false));
  }, [token]);

  const openPdf = () => {
    if (!pdfBase64) return;
    try {
      const bytes = base64ToUint8(pdfBase64);
      const blob = new Blob([bytes], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank', 'noopener,noreferrer');
      setTimeout(() => URL.revokeObjectURL(url), 60_000);
    } catch (e) {
      console.error('Failed to open PDF:', e);
      alert('Unable to open PDF.');
    }
  };

  const submitResponse = async (response) => {
    if (!token) return;
    try {
      const res = await API.post(`/api/flha/acknowledgment/${encodeURIComponent(token)}`, { response });
      setSubmitted(true);
      setSubmittedStatus(res?.data?.status || response);
    } catch (e) {
      console.error('Failed to submit FLHA response:', e);
      alert('Failed to submit. Please try again.');
    }
  };

  if (loading) return <div style={{ padding: 20 }}>Loading...</div>;
  if (!token) return <div style={{ padding: 20 }}>Invalid link</div>;
  if (!invitation) return <div style={{ padding: 20 }}>Invitation not found or expired.</div>;

  if (submitted) {
    return (
      <div style={{ padding: 20 }}>
        <h2>Response recorded</h2>
        {String(submittedStatus).toLowerCase() === 'disagreed' ? (
          <p>Thank you — your response has been recorded. The instructor has been notified.</p>
        ) : (
          <p>Thank you — your acknowledgement has been recorded.</p>
        )}
      </div>
    );
  }

  return (
    <div style={{ padding: 20, maxWidth: 760 }}>
      <h2>Training FLHA Acknowledgement</h2>
      <p>Please review the Field Level Hazard Assessment and respond.</p>

      {submission && (
        <div style={{ margin: '12px 0' }}>
          <div><strong>Training Location:</strong> {submission.trainingLocation || 'N/A'}</div>
          <div><strong>Training Date:</strong> {submission.trainingDate || 'N/A'}</div>
          <div><strong>Training Time:</strong> {submission.trainingTime || 'N/A'}</div>
        </div>
      )}

      <div style={{ marginTop: 16 }}>
        <button onClick={openPdf} disabled={!pdfBase64}>
          View FLHA PDF
        </button>
      </div>

      <div style={{ marginTop: 20 }}>
        <p><strong>Acknowledgement:</strong> I understand and acknowledge the hazards and controls described in this FLHA.</p>
        <div style={{ display: 'flex', gap: 12, marginTop: 12, flexWrap: 'wrap' }}>
          <button onClick={() => submitResponse('yes')}>Yes</button>
          <button onClick={() => submitResponse('no')}>No</button>
        </div>
      </div>
    </div>
  );
}
